<template>
  <div>
    <a-tooltip
      :title="title || $t('okr.list.notAligned')"
      :placement="placement"
    >
      <div
        :style="{
          '--size': size + 'px',
          '--border-size': (size - 2) + 'px'
        }"
        class="to-be-aligned-dot"
      />
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ToBeAlignedDot',
  props: {
    title: {
      type: String,
      default: undefined
    },
    placement: {
      type: String,
      default: undefined
    },
    size: {
      type: Number,
      default: 8
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }

  to {
    opacity: 0;
    transform: scale3d(1.5, 1.5, 1);
  }
}

.rings(@duration, @delay) {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border: var(--border-size) solid rgba(255, 90, 0, 0.4);
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  animation-name: ripple;
  animation-duration: @duration;
  animation-iteration-count: infinite;
  animation-delay: @delay;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
}

.to-be-aligned-dot {
  position: relative;
  display: flex;
  width: var(--size);
  height: var(--size);
  z-index: 2;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  background-color: #FF5A00;

  &:before {
    .rings(3s, 0);
  }

  &:after {
    .rings(3s, 0.5s);
  }
}
</style>
